import React, { useEffect, useRef } from "react";

const ProgressStep = ({ currentStep, steps, onStepClick }) => {
  const trackRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    const index = Math.max(0, Math.min(steps.length - 1, currentStep - 1));
    const el = itemRefs.current[index];
    const parent = trackRef.current;
    if (!el || !parent) return;
    const target = el.offsetLeft - parent.clientWidth / 2 + el.offsetWidth / 2;
    parent.scrollTo({ left: target, behavior: "smooth" });
  }, [currentStep, steps.length]);

  return (
    <div className="relative w-full">
      <div className="overflow-x-auto no-scrollbar items-center">
        <div
          ref={trackRef}
          className="flex flex-nowrap items-center gap-4 w-max px-8 scroll-smooth"
        >
          {steps.map((label, index) => {
            const active = index + 1 === currentStep;
            const completed = index + 1 < currentStep;
            return (
              <div
                key={index}
                ref={(el) => (itemRefs.current[index] = el)}
                className="flex items-center whitespace-nowrap justify-center"
              >
                <button
                  type="button"
                  onClick={() => onStepClick && onStepClick(index + 1)}
                  className={`w-8 h-8 rounded-full flex items-center justify-center font-semibold text-sm shrink-0 ${
                    completed
                      ? "bg-gradient-to-br from-ananas to-[#B7E3B4]/40 text-[#3a3a3a] "
                      : active
                      ? "bg-gradient-to-br from-ananas to-[#B7E3B4]/40 text-[#3a3a3a]  animate-pulse"
                      : "bg-gradient-to-br from-ananas to-[#B7E3B4]/40 text-[#3a3a3a] "
                  }`}
                >
                  {completed ? (
                    <svg
                      className="w-4 h-4"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    index + 1
                  )}
                </button>

                <span
                  className={`ml-2 text-sm ${
                    active ? "text-primary font-bold" : "text-primary/80"
                  }`}
                >
                  {label}
                </span>

                {index < steps.length - 1 && (
                  <div
                    className={`h-1 w-12 ml-2 ${
                      completed ? "bg-primary" : "bg-gray-200"
                    }`}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressStep;
